import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=06b83aaa&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b83aaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06b83aaa')) {
      api.createRecord('06b83aaa', component.options)
    } else {
      api.reload('06b83aaa', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=06b83aaa&scoped=true&", function () {
      api.rerender('06b83aaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24SOmIuxubEzt/JS/comp/SearchFilterTokens.vue"
export default component.exports